"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var ProgressBar = require("progressbar.js");
omi_1.define('m-path-progress', (_a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function (props) {
            var _this = this;
            var containerStyle = this.props.containerStyle;
            return omi_1.h("div", __assign({}, omi_1.extractClass(props), { style: containerStyle, ref: function (e) { _this.progressBar = e; } }));
        };
        class_1.prototype.installed = function () {
            this._create(this.props, null);
        };
        class_1.prototype.uninstall = function () {
            this._destroy();
        };
        class_1.prototype._create = function (props, oldProps) {
            console.log(this.props);
            console.log(props.type);
            // setdata function is not used to prevent a new render cycle
            // This handling happens outside of React component's lifecycle
            var container = this.progressBar;
            this.shape = new ProgressBar[props.type](container, props.options);
            if (props.initialAnimate) {
                if (oldProps) {
                    this._setProgress(oldProps.progress);
                }
                this._animateProgress(props.progress);
            }
            else {
                this._setProgress(props.progress);
            }
            this._setText(props.text);
        };
        class_1.prototype._destroy = function () {
            if (this.shape) {
                this.shape.destroy();
                this.shape = null;
            }
        };
        class_1.prototype._animateProgress = function (progress) {
            this.shape.animate(progress);
        };
        class_1.prototype._setProgress = function (progress) {
            this.shape.set(progress);
        };
        class_1.prototype._setText = function (text) {
            if (text) {
                this.shape.setText(text);
            }
        };
        return class_1;
    }(omi_1.WeElement)),
    _a.css = "\n  :host {\n    display: block;\n  }\n  ",
    _a.defaultProps = {
        options: {},
        progress: 0,
        text: null,
        initialAnimate: false,
        containerStyle: {}
    },
    _a.propTypes = {
        type: String,
        options: Object,
        progress: Number,
        text: String,
        initialAnimate: Boolean,
        containerStyle: Object
    },
    _a));
